var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_7695_58)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7695_58",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7695_58",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7695_58",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEuklEQVR4nO2cTYgcRRTHyyQoRvxcYqZqlhVCECIG8Sx6EKInEdRFSQT14MGPECRTr8eVMH6AYg7mkJMHwYsgGhH14kVW8ZJDJEHGfm8GTdRDQAhGUUHNZkdqZyd218xO4ro7r6vq/aEOu9V0Tf9+9dn7oZREIpFIJBOOAeqFWXBBZ7hbxRZ+sCRS4hFC8Y0UfqAkUqIQYumc/3Ud8CEVetjBwupKrYEPaqC/o5u+uMGaVRb32aOUErKQKKWELiQ6KTEIiUpKLEKikRKTkCikxCYkeCkxCglaSqxCgpUSs5Agpaw3kP+btWg/KCkpCAlKSipCgpGSkpAgpHAvzoahQ1RaCjdYwzRCKyslVSGVlZKykEpK4QZysUyi/UpJESH9uF+QGPWLE2rSCVWICWxqXPcHrvrnM6kJSaUoEULsEkQI8IMXIcAPOyohKtCYqj+nCCERwhkZIRVLtEJSKUqEELsEEQL84EUI8MOOSogKNKbqzylCSIRwRkZIxRKtkFSKEiHELkGEAD94EQL8sKMSogKNqfpzihASIZyREVKxRCsklaJECLFLECHAD16EAD9sEQL8gJMWoi2dNkAHtO3caZr5zbWsc5ex9KoGPMsNOkUhR7Zl3107qs2ZuVxrwOPcsNMRYukD1eptGNeuztozBvBXbuDxC7F0SreObb6UtjXgG9zAoxdSg/yBUgOt3gYHXgORgfyxYlU9o7u5gUcuBE/6U5UGOlio/2Z42uKHHq0QDfRK6d5Z93YDuFgQ8lOxvvZ8dws38MiF5Lu8e79ZusZSu1g/3WxvX/l+uDj8t+Pj2sY/3d+Wi5AimGY+VQSuAb/1hLxTqm/k94wEaOnwTftOXXdLq325tvjyihIsdTTkz9ahO+3ud8Pe7jUa6D0ZIf0evVBaP2Z7G8vTFfXqlmbLIwhfGAHviD+KtaX3PRE/G8AnRm2ttzTaNRHS79V/lCC2jm32ev1v/nZYAx4tg8Zf3KHRh1zPOrcVZMyPumaQG5udbSJkAGsY+Nl/heBrxToH1Vg870l7eiXQBugrt31WrflNIy+Y7W2cznCnsfiFCFkGunV/fmtZCH2y3KvPuDWhVGfxRQ/c5+NO94N1wo9r070ZMEC/yy7Ln/8zeqbUqy09vDwV7Sl+373j6q8DF3ZUJ90WuHjN9HM/XqnGpneZtrivv7uSbe/o7aelT/1pRFuc81F6O6fva9DZUbqgNb9JW/zMH1UXRDfzKQ300XqKGBQ16aztA+Cie82uxsTN89rSX2790Jbe9keGiwZ8afmeB4bqGnSHsfTDJGREIGTpgPbu2PYyeqp4dvDjtsaDA97SdNTAx90U50aRsXho6H9aiZBLgJDhfavrHJ1HlkbPBIFHP0KMxS/9E/vF4hZwY/F1/yBZhaImnbV9APxw+97uFf9FhIbOk0OvWCpU1KSzhjIWZppfX+/fX2e42y3SOqP7NeC9tYweNRattvSxO5lzA49XiKVzW/efuKokw+JcFaehlH4e8taUxavdGuLe7HLDTF5IHwAuDL2jCrgEPUJiLEqEELsEEQL84EUI8MMWIcAPWIQAP1QRAvwgRUgF4BkRwg/MiBB+SEaE8IMxqQiRSCQSiUo9/wCPPcEquOwt2wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLease);
export default __webpack_public_path__ + "static/media/lease.02d44906114636247405b5438e8acbb8.svg";
export { ForwardRef as ReactComponent };